import { render } from "./CategoryTwelveDuplicateDialog.vue?vue&type=template&id=28dc80cc&scoped=true"
import script from "./CategoryTwelveDuplicateDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryTwelveDuplicateDialog.vue?vue&type=script&lang=ts"

import "./CategoryTwelveDuplicateDialog.vue?vue&type=style&index=0&id=28dc80cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28dc80cc"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
